export var GraphData = {
	methods: {},
	computed: {
		graphData: function() {
			return {
				tooltip: {
					trigger: "item",
					// formatter: '{b}<br/>{c}%',
					formatter: function (params) {
						return `${params.name}<br />
								${params.data.data ? params.data.data : ""} (${params.value}%)`;
						
					  }
				},
				legend: this.getLegend,
				color: this.graphColors,
				series: this.graphSeries,
			};
		}
	},
	data() {
		return {
			getTitle: {
				text: "",
				show: true,
				top: 0,
				left: "center",
				textStyle: {
					fontSize: "10",
					color: "#484848"
				}
			},
			getLegend:  {
				top: 200,
				show: true,
				textStyle: {
					fontSize: "10",
					color: "#484848"
				}
			},
			graphColors: [],
			graphSeries: [],
			initOptions: { renderer: "svg" },
			loading: true
		};
	}
};
